import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";

import { useIsOnline } from "../../../hooks";

interface Props {
  redirectUrl: string;
}

const CreateReportButton = ({ redirectUrl }: Props) => {
  const navigate = useNavigate();
  const isOnline = useIsOnline();
  return (
    <Button
      variant="outline"
      ml={5}
      onClick={() => navigate(redirectUrl)}
      disabled={!isOnline}>
      Create Report
    </Button>
  );
};
export default CreateReportButton;
